import type { Locale } from '../i18n';

/** "11 Jun" style short date for a UTC ISO string, localized. */
export function shortDate(iso: string, locale: Locale): string {
  const d = new Date(iso);
  return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
}

/** "23:00" local kickoff time. */
export function shortTime(iso: string, locale: Locale): string {
  const d = new Date(iso);
  return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

/** Day key (YYYY-MM-DD, local) for grouping matches into matchdays. */
export function dayKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
